import React from "react";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react.js";
import SwiperCore, { Pagination, Navigation, Autoplay } from "swiper";

import styles from "./FeedSlider.module.scss";

import { feed_data } from "../../data";

SwiperCore.use([Pagination, Navigation, Autoplay]);

const FeedSlider = () => {
  return (
    <div className={styles["feed-slider-root"]}>
      <div className={styles["content"]}>
        <Swiper
          navigation={false}
          centeredSlides={true}
          freeMode={true}
          slidesPerView="auto"
          preloadImages
          pagination={{
            clickable: true,
            type: "bullets",
            bulletActiveClass: styles.bullet_active,
            bulletClass: styles.bullet,
          }}
          autoplay={{
            delay: 1500,
            disableOnInteraction: false,
          }}
          loop={true}
        >
          {feed_data.map((item, i) => (
            <SwiperSlide key={i}>
              <img src={item} alt="event_details" />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default FeedSlider;
